<template>
	
	
	<div class="row">

		<div class="col-md-6 offset-md-3 mb-2 mt-4" v-loading="thinking.save">

			<div class="form">


				<!--<div class="text-center">
					<img :src="selectedStudio.image" class="mb-3 img img-fluid img-thumbnail" style="max-width: 100px; margin: 0px auto" />
					<h3 class="mb-1" style="color: #cc6600">{{selectedStudio.title}}</h3>
					<h5>{{selectedStudio.features}}</h5>
					<h5 class="mb-1">{{selectedStudio.street}}</h5>
					<h5>{{selectedStudio.city}} {{selectedStudio.state}} &nbsp;{{selectedStudio.zip}}</h5>
					<h5>{{selectedStudio.phone}}</h5>
				</div>

				<hr />-->

				<p class="lead text-center mb-2">
					Your Membership
				</p>

				<div class="text-center">
					<h3 class="mb-1" style="color: #cc6600">{{selectedPlan.title}}</h3>
					<h5>${{selectedPlan.price}}</h5>
					<ul class="ml-0 pl-0" style="list-style: none">
						<li>First 30 days unlimited classes.</li>
						<li>Cancel during the first 30 days... </li>
						<li>Find Netflix or something or sign-up for a trial somewhere to get some wordz</li>

					</ul>
				</div>


				<hr />

				<p class="lead text-center mb-2">
					Your Payment Method
				</p>

				<div class="text-center mb-5">
					<template v-if="payment.method === 'card'">
						<h5><span style="text-transform: uppercase">{{payment.cardType}}</span> ending in {{payment.cardNumberReal.slice(payment.cardNumberReal.length - 4)}}</h5>
					</template>
				</div>


				<Authorization class="mb-5"></Authorization>


				<div class="row">
					<div class="col-2 form-group initials">
						<el-input class="sig" style="font-family: 'Homemade Apple', cursive;" />
						<span class="help-block">Initials</span>						
					</div>
					<div class="col-8 form-group sig-label monthly" style="display: none"> <strong>All changes require 1 month written notice prior to Auto-Debit Cycle Day</strong> </div>
					<div class="col-8 form-group sig-label prepaid" style="display: none"> <strong>I understand this membership cannot be refunded in full, nor partially.</strong> </div>
				</div>
				

				<FinePrint></FinePrint>




			</div>

			<router-link :to="{ name: 'payment' }" tag="a" class="text-primary ">Go Back</router-link>
			
		</div>

		

	</div>

	
	
</template>

<script>
	
	import { mapGetters } from "vuex";
	import { rest } from "@/utilities/rest.js";
	import FinePrint from "./FinePrint";
	import Authorization from "./Authorization";

	export default {
		name: "payment",
		components: {
			FinePrint,
			Authorization
		},
		data() {
			return {

				state: {
					
				},

				errorsInternal: {
					
				},

				thinking: {
					save: false
				}			

												
			}
		},

		created() {
			//if (!this.selectedStudio || !this.selectedPlan) {
			//	this.$router.push({ name: "select-studio" });
			//}
			if (!this.selectedPlan) {
				this.$router.push({ name: "select-membership" });
			}
		},

		computed: {
			...mapGetters({
				selectedStudio: "selectedStudio",
				selectedPlan: "selectedPlan",
				locations: "locations",
				plans: "plans",
				profile: "profile",
				payment: "payment"
			})
			
		},

		methods: {


			
			
		},

		watch: {
			
		}
	}
</script>

